module.exports = __webpack_public_path__ + "static/media/shopping-cart.f031a3bc.png";